import React, {useState, useCallback} from 'react'
import {AUTH_LOGIN_MAX_ATTEMPT} from 'consts'
import {useTranslation} from 'i18n'
import {requestData} from 'services'
import {formatCooldownTime, maskEmail, maskPhone} from 'utils'
import {useDispatch, useSelector} from 'lib/redux'
import {GiftShopTemplateOTPModal} from '../../../template'
import {GiftShopAddBankAccountVerificationModalProps} from './GiftShopAddBankAccountModalProps'

export default function GiftShopAddBankAccountVerificationModal({
  verificationMethod,
  onCancel,
  onSuccess,
  onResend,
  onSuspend,
}: GiftShopAddBankAccountVerificationModalProps) {
  const {translate} = useTranslation()
  const {email, phone_code, phone_number} = useSelector('user') || {}
  const {addBankAccountOtp} = useSelector('giftshopState')
  const {update} = useDispatch()

  const stateError = useState(false)
  const setError = stateError[1]

  const stateErrorMessage = useState('')
  const setErrorMessage = stateErrorMessage[1]

  const handleVerify = useCallback(
    (codes: string) => {
      requestData('giftshop_post_bank_verify_otp', {
        data: {verification_method: verificationMethod, otp: codes},
        onRequestSuccess: ({status, data: {detail}}) => {
          if (status === 200) {
            setError(false)
            onSuccess()
          } else if (status === 400 && detail) {
            const {attempt} = detail
            setError(true)
            setErrorMessage(
              translate('giftShop:incorrectOTP')
                .concat('. ')
                .concat(
                  translate('auth:attemptLeft', {
                    count: AUTH_LOGIN_MAX_ATTEMPT - parseInt(attempt, 10),
                  }),
                ),
            )
          } else if (status === 423 && detail) {
            setError(false)
            update('giftshopState', {
              addBankAccountSuspendTime: new Date().getTime(),
              addBankAccountSuspendDuration: formatCooldownTime(
                detail.suspend_duration,
              ),
            })
            onSuspend(detail.suspend_duration)
          } else {
            setError(true)
          }
        },
      })
    },
    [
      onSuccess,
      onSuspend,
      setError,
      setErrorMessage,
      translate,
      update,
      verificationMethod,
    ],
  )

  return (
    <GiftShopTemplateOTPModal
      stateError={stateError}
      dataToVerify={
        verificationMethod === 'email' && email
          ? maskEmail(email)
          : phone_code && phone_number && maskPhone(phone_code, phone_number)
      }
      verificationMethod={verificationMethod}
      timeRemaining={addBankAccountOtp}
      onCancel={onCancel}
      onVerify={handleVerify}
      onResend={onResend}
      stateErrorMessage={stateErrorMessage}
    />
  )
}
